import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { SpecialRequestItem } from 'src/app/core/models/special-requests.model';

@Component({
  selector: 'app-special-request-modal',
  templateUrl: './special-request-modal.component.html',
  styleUrls: ['./special-request-modal.component.scss']
})
export class SpecialRequestModalComponent implements OnChanges {
  @Input() isActive: boolean;
  @Input() specialRequests: SpecialRequestItem[];
  @Input() name: string;

  @Output() closeModal = new EventEmitter<boolean>();

  onlySpecialRequests: SpecialRequestItem[] = [];
  onlyAncillaries: SpecialRequestItem[] = [];

  constructor() {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes && this.specialRequests) {
      this.onlySpecialRequests = [];
      this.onlyAncillaries = [];

      this.specialRequests.forEach((SR) => {
        SR.coupons.length > 0 ? this.onlyAncillaries.push(SR) : this.onlySpecialRequests.push(SR);
      });
    }
  }
}
